import React from 'react';
import { useDialogsContext } from '../../../contexts/Dialog';
import DialogContent from './DialogContent';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

interface Props {
  startDate: string;
}

export default function DuplicateLineDialog({ startDate }: Props) {
  const dialog: any = useDialogsContext();

  function handleClose() {
    dialog.close('duplicateLine');
  }

  return (
    <Dialog
      open={dialog.duplicateLine}
      header="Create a new Line"
      description="Your last Line for this product will be replicated"
      isDescriptionInHeader={true}
      onClose={handleClose}
    >
      <DialogContent initialDate={startDate} handleClose={handleClose} />
    </Dialog>
  );
}
